import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';
import { Base_URL, imageBaseURL } from '../../actions/API_endpoint';

const Blog = () => {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await axios.get(`${Base_URL}/api/blogs`);
                if (response.data.success) {
                    setBlogs(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching blogs:", error);
            }
        };
        fetchBlogs();
    }, []);

    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow pt-32 pb-20 bg-dark-secondary">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-center text-white mb-16">
                        NVCTI <span className="text-nvcti-orange">Blog</span>
                    </h1>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
                        {blogs.length > 0 ? (
                            blogs.map((blog) => (
                                <Link to={`/blog/${blog.slug}`} key={blog.id} className="block group h-full">
                                    <div className="bg-dark-tertiary rounded-2xl shadow-xl overflow-hidden hover:shadow-accent-primary/20 transition-all duration-300 h-full border border-white/5 flex flex-col">
                                        <div className="h-56 bg-white/5 w-full flex items-center justify-center text-gray-500 group-hover:bg-white/10 transition-colors overflow-hidden relative">
                                            {blog.image_url ? (
                                                <img
                                                    src={`${imageBaseURL}${blog.image_url}`}
                                                    alt={blog.title}
                                                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                                />
                                            ) : (
                                                <span className="text-5xl">📝</span>
                                            )}
                                        </div>
                                        <div className="p-8 flex flex-col flex-grow">
                                            <h2 className="text-2xl font-bold text-white mb-3 group-hover:text-nvcti-orange transition-colors line-clamp-2">
                                                {blog.title}
                                            </h2>
                                            <p className="text-gray-400 mb-6 line-clamp-3 leading-relaxed flex-grow">
                                                {blog.content.substring(0, 150)}...
                                            </p>
                                            <div className="flex items-center text-nvcti-orange font-bold hover:gap-2 transition-all mt-auto">
                                                Read More <span className="ml-2">&rarr;</span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            ))
                        ) : (
                            <div className="col-span-full text-center text-gray-400 text-xl">
                                No blogs found.
                            </div>
                        )}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Blog;
